import React, {useEffect} from "react";

import {Spin} from "antd";
import {useForm} from "antd/es/form/Form";

import api from "../../api";
import {StandardForm} from "../helpers/forms/StandardForm";
import {ModalWindow} from "../helpers/modals/ModalWindow";

export function CreateApprovalBucket(props) {
	const [workflows, setWorkflows] = React.useState([]);
	const [loading, setLoading] = React.useState(false);

	const [workflowOptions, setWorkflowOptions] = React.useState([]);
	const [values, setValues] = React.useState([]);

	const [form] = useForm();

	const getWorkflows = () => {
		api.post(`/projects/${props.projectId}/workflows`, {})
			.then(json => {
				setWorkflows(json.data.data);
				setWorkflowOptions(createWorkflowOptions(json.data.data));
			})
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		getWorkflows();
		if (!props.addingBucket) {
			form.resetFields();
		}
	}, [props.addingBucket, props.projectId]);

	useEffect(() => {
		setValues(getValuesFields());
	}, [workflowOptions]);

	const closeModal = () => {
		props.onClose();
	};

	const submitForm = () => {
		form.submit();
	};

	const createBucket = values => {
		values["material_identifiers"] = props.selectedKeys.map(material => material._id);
		setLoading(true);
		api.post(`/projects/${props.projectId}/scenarios/${props.scenarioId}/approval-buckets`, values)
			.then(json => {
				props.setSelectedKeys([]);
				props.refresh();
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => setLoading(false));
		closeModal();
	};

	const createWorkflowOptions = () =>
		workflows.map(workflow => ({
			value: workflow._id,
			label: workflow.name,
		}));

	const getValuesFields = () => [
		{label: "Bucket Name", name: "name", _type: "text", required: true},
		{label: "Bucket Description", name: "description", _type: "text", required: true},
		{
			label: "Workflow",
			name: "workflow_id",
			_type: "select-object",
			required: true,
			options: workflowOptions,
		},
	];

	return (
		<ModalWindow
			title={"Add new Approval Bucket"}
			isModalVisible={props.addingBucket}
			onOk={submitForm}
			onCancel={closeModal}>
			<Spin spinning={loading}>
				<StandardForm form={form} initialValues={{}} onFinish={createBucket} fields={values} />
			</Spin>
		</ModalWindow>
	);
}
